module.exports = __webpack_public_path__ + "static/media/Logo.2173583c.png";